import {ExclamationCircleFilled} from '@ant-design/icons';
import {Modal, Typography, Button, Flex} from 'antd';
import React from 'react';

import {blockModelMessages} from '../../constants/blockPageConstatnts';

const {Title, Paragraph} = Typography;

interface ExternalStakeholderLimitModalProps {
  maxLimit: number;
  open: boolean;
  onUpgrade: () => void;
  onCancel: () => void;
}

const ExternalStakeholderLimitModal: React.FC<
  ExternalStakeholderLimitModalProps
> = ({maxLimit, open, onUpgrade, onCancel}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={650}
      maskClosable={false}
      closable={false}
    >
      <Flex vertical align="center" justify="center" gap={16}>
        <ExclamationCircleFilled style={{fontSize: 48, color: '#FACC15'}} />

        <Title level={5} style={{marginBottom: 0}}>
          {blockModelMessages.externalStakeholder.title.limitReached}
        </Title>

        <Paragraph
          style={{
            textAlign: 'center',
            color: '#595959',
            marginTop: 8,
            marginBottom: 24
          }}
        >
          {blockModelMessages.externalStakeholder.description.limitReached(
            maxLimit
          )}
        </Paragraph>

        <Flex justify="center" gap={12}>
          <Button
            type="primary"
            onClick={onUpgrade}
            style={{
              minWidth: 120
            }}
          >
            Upgrade Plan
          </Button>
          <Button onClick={onCancel} style={{minWidth: 120}}>
            Cancel
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ExternalStakeholderLimitModal;
